// Keeps a scanned QR link alive across the login redirect.
//
// capturePendingScan() runs once when the app loads (AdminApp.js module level). If the app was opened on
// /stock-scan it remembers the full link. <PendingScanRedirect /> then reopens it once the user is logged in.
// localStorage (not sessionStorage) is used so it also survives phone browsers / in-app browsers that open the
// login in a different tab. The link expires after 15 minutes.
import { SCAN_PATH } from "./stockQrUtils";

const KEY = "pending_stock_scan";
const TTL_MS = 15 * 60 * 1000;

export const capturePendingScan = () => {
  try {
    if (window.location.pathname === SCAN_PATH) {
      localStorage.setItem(
        KEY,
        JSON.stringify({
          url: window.location.pathname + window.location.search,
          ts: Date.now(),
        }),
      );
    }
  } catch {
    /* storage unavailable */
  }
};

export const peekPendingScan = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { url, ts } = JSON.parse(raw);
    if (!url || Date.now() - ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return url;
  } catch {
    return null;
  }
};

export const clearPendingScan = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};
